export default "__VITE_ASSET__DEJXeHYX__"